import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const KeyProductFeatureName = ({
  name = null,
  simple = false,
  inverseText = false,
  responsiveTileGrid = false
}) => {
  const keyProductFeatureNameClasses = classNames('sui-flex', {
    'sui-w-full': responsiveTileGrid,
    'sui-w-1/2': !responsiveTileGrid,
  });
  return (
    <>
      {simple || inverseText ? (
        <>
          <div className={keyProductFeatureNameClasses}>
            <Typography truncate variant="body-xs" color="subtle">{name}</Typography>
          </div>
        </>
      ) : (
        <Typography variant="h4">{name}</Typography>
      )}
    </>
  );
};

KeyProductFeatureName.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  simple: PropTypes.bool,
  inverseText: PropTypes.bool,
  responsiveTileGrid: PropTypes.bool
};

export default KeyProductFeatureName;
